<div class="page-wrapper member-detail-page">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > <a routerLink="/members">Adhérents</a> > 
          {{ detailMember?.companyName }}
        </div>
      </div>
    </div>
  </div>
  <div class="member-detail-page-inner">
    <div class="container">
      <div class="wrap-title d-flex align-items-center">
        <img src="{{logo}}" alt="" />
        <h2 class="title mb-0">{{ detailMember?.companyName }}</h2>
      </div>
    </div>
    <div class="container">
      <div class="info-general d-flex">
        <div class="block-left">
          <p>Code : <span>{{ detailMember?.code }}</span></p>
          <p>SIRET : <span>{{ detailMember?.siret }}</span></p>
          <p>TVA Intracommunautaire : <span>{{ detailMember?.vat }}</span></p>
        </div>
        <div class="block-right">
          <p class="title">Coordonnées</p>
          <div class="d-flex justify-content-between gap-2 group-info-general">
            <div>
              <p>Téléphone :</p>
              <a href="tel:{{ detailMember?.phone }}">{{ detailMember?.phone ? detailMember?.phone : '' }}</a>
            </div>
            <div>
              <p>Email :</p>
              <a href="mailto:{{detailMember?.email}}">{{ detailMember?.email ? detailMember?.email : '' }}</a>
            </div>
            <div>
              <p>Site web :</p>
              <a target="_blank" href="{{detailMember?.website}}">{{ detailMember?.website ? detailMember?.website : ''
                }}</a>
            </div>
            <div>
              <p class="address">
                Adresse :
                <span>{{detailMember?.address}}<br />
                  {{detailMember?.postcode}}, {{detailMember?.city}} {{detailMember?.country?.labels?.fr_FR}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap-contacts py-5">
      <div class="container">
        <h3 class="title text-center">CONTACTS</h3>
        <div class="wrap-table">
          <p-table [value]="contactData">
            <ng-template pTemplate="header">
              <tr>
                <th class="font-bold" style="min-width: 180px">Fonction</th>
                <th class="font-bold">Prénom</th>
                <th class="font-bold" style="min-width: 135px">Nom</th>
                <th class="font-bold" style="min-width: 150px; max-width: 150px">
                  Téléphone
                </th>
                <th class="font-bold" style="width: 200px">Email</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="font-bold">{{ item?.job ? item?.job : '-' }}</td>
                <td class="">{{ item?.firstName ? item?.firstName : '-' }}</td>
                <td class="">{{ item?.lastName ? item?.lastName : '-' }}</td>
                <td class="underline">
                  <a *ngIf="item?.phone" href="tel:{{ item?.phone }}">+{{ item?.phone }}</a>
                  <p *ngIf="!item?.phone">-</p>
                </td>
                <td class="underline">
                  <a *ngIf="item?.email" href="mailto:{{ item?.email }}">{{ item?.email }}</a>
                  <p *ngIf="!item?.email">-</p>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>